(function () {
  const SELECTORS = [
    // Dawn / OS2.0 common
    ".product-grid .grid__item",
    ".collection .grid__item",
    ".grid--4-col-desktop .grid__item",
    ".grid--3-col-tablet .grid__item",

    // Card wrappers / product cards (many themes)
    ".card-wrapper",
    ".product-card",
    ".product-item",
    ".product-grid-item",

    // Fallback: any product in product list sections
    "[data-product-id]"
  ];

  function getTargets(root = document) {
    const set = new Set();
    SELECTORS.forEach((sel) => {
      root.querySelectorAll(sel).forEach((el) => set.add(el));
    });

    // Filter only visible/real product tiles (avoid header etc.)
    return Array.from(set).filter((el) => {
      // ignore if inside slideshow etc.
      return el.offsetParent !== null;
    });
  }

  const ENABLE_CARD_IMAGE_ANIM =
    document.body.classList.contains("template-index") ||
    document.body.classList.contains("template-collection");

  function applyCardImageAnimation(root = document) {
    if (!ENABLE_CARD_IMAGE_ANIM) return;

    const images = root.querySelectorAll(
      ".m-product-card__main-image img, .m-product-card__hover-image img, .spg__img--main"
    );
    if (!images.length) return;

    images.forEach((img) => {
      if (img.dataset.cardAnimBound === "true") return;
      img.dataset.cardAnimBound = "true";

      const start = () => {
        img.classList.remove("m-card-image-animate");
        // Force reflow to restart the animation when swapping images.
        void img.offsetWidth;
        img.classList.add("m-card-image-animate");
      };

      if (img.complete) {
        requestAnimationFrame(start);
      } else {
        img.addEventListener("load", start, { once: true });
      }
    });
  }

  function applyReveal(root = document) {
    const items = getTargets(root);
    if (!items.length) return;

    // assign stagger delays
    items.forEach((el, i) => {
      el.classList.add("reveal-item");
      el.style.setProperty("--reveal-delay", `${Math.min(i * 70, 600)}ms`);
    });

    // IntersectionObserver reveal
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-revealed");
          io.unobserve(entry.target);
        });
      },
      { root: null, threshold: 0.12, rootMargin: "0px 0px -5% 0px" }
    );

    items.forEach((el) => io.observe(el));

    applyCardImageAnimation(root);
  }

  // Run on normal page load
  document.addEventListener("DOMContentLoaded", () => {
    applyReveal(document);
    applyCardImageAnimation(document);
  });

  // Shopify theme editor support (sections reload)
  document.addEventListener("shopify:section:load", (e) => {
    applyReveal(e.target);
    applyCardImageAnimation(e.target);
  });

  // If products are rendered via AJAX (some themes)
  document.addEventListener("shopify:section:select", (e) => {
    applyReveal(e.target);
    applyCardImageAnimation(e.target);
  });
})();
